webpackJsonp([0,1],[
/* 0 */
/***/ (function(module, exports) {


function createCanvas() {
  var el = document.createElement('canvas');
  document.body.appendChild(el);
  return el;
}

var canvasEl = createCanvas();

if (canvasEl.getContext) {
  var ctx = canvasEl.getContext('2d');

  ctx.fillStyle = 'rgb(200, 0, 0)';
  ctx.fillRect(10, 10, 50, 50);

  ctx.fillStyle = 'rgba(0, 0, 200, 0.5)';
  ctx.fillRect(30, 30, 50, 50);
}

/***/ }),
/* 1 */
/***/ (function(module, exports) {


function createCanvas() {
  var el = document.createElement('canvas');
  document.body.appendChild(el);
  return el;
}

var canvasEl = createCanvas();

if (canvasEl.getContext) {
  var ctx = canvasEl.getContext('2d');
  var rectangle = new Path2D();
  rectangle.rect(10, 10, 50, 50);

  var circle = new Path2D();
  circle.moveTo(125, 35);
  circle.arc(100, 35, 25, 0, 2 * Math.PI);

  ctx.stroke(rectangle);
  ctx.fill(circle);
}

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__colors__);


/***/ }),
/* 3 */
/***/ (function(module, exports) {


function createCanvas() {
  var el = document.createElement('canvas');
  document.body.appendChild(el);
  return el;
}

var canvasEl = createCanvas();

if (canvasEl.getContext) {
  var ctx = canvasEl.getContext('2d');
  ctx.font = '48px serif';
  ctx.fillText('Hello world', 10, 50);
}

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__1_jpg__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__1_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__1_jpg__);


function createCanvas() {
  var el = document.createElement('canvas');
  document.body.appendChild(el);
  return el;
}

var canvasEl = createCanvas();

if (canvasEl.getContext) {
  var ctx = canvasEl.getContext('2d');
  var img = new Image();
  img.onload = function () {
    ctx.drawImage(img, 0, 0, 150, 150);
  };
  img.src = __WEBPACK_IMPORTED_MODULE_0__1_jpg___default.a;
}

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__save__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__save___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__save__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rotate__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rotate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__rotate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translate__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__translate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__translate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__transform__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__transform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__transform__);





/***/ }),
/* 6 */
/***/ (function(module, exports) {


function createCanvas() {
  var el = document.createElement('canvas');
  document.body.appendChild(el);
  return el;
}

var canvasEl = createCanvas();

if (canvasEl.getContext) {
  var ctx = canvasEl.getContext('2d');

  for (var i = 0; i < 6; i++) {
    for (var j = 0; j < 6; j++) {
      ctx.fillStyle = 'rgb(' + Math.floor(255 - 42.5 * i) + ',' + Math.floor(255 - 42.5 * j) + ',0)';
      ctx.fillRect(j * 25, i * 25, 25, 25);
    }
  }
}

/***/ }),
/* 7 */
/***/ (function(module, exports) {


function createCanvas() {
  var el = document.createElement('canvas');
  document.body.appendChild(el);
  return el;
}

var canvasEl = createCanvas();

if (canvasEl.getContext) {
  var ctx = canvasEl.getContext('2d');

  ctx.save();

  ctx.fillStyle = '#0095DD';
  ctx.fillRect(30, 30, 100, 100);
  ctx.rotate(Math.PI / 180 * 25);

  ctx.fillStyle = '#4D4E53';
  ctx.fillRect(30, 30, 100, 100);
  ctx.restore();

  ctx.fillStyle = '#0095DD';
  ctx.fillRect(150, 30, 100, 100);

  ctx.translate(200, 80);
  ctx.rotate(Math.PI / 180 * 25);
  ctx.translate(-200, -80);
  ctx.fillStyle = '#4D4E53';
  ctx.fillRect(150, 30, 100, 100);
}

/***/ }),
/* 8 */
/***/ (function(module, exports) {


function createCanvas() {
  var el = document.createElement('canvas');
  document.body.appendChild(el);
  return el;
}

var canvasEl = createCanvas();

if (canvasEl.getContext) {
  var ctx = canvasEl.getContext('2d');
  ctx.fillRect(0, 0, 150, 150);
  ctx.save();

  ctx.fillStyle = '#09F';
  ctx.fillRect(15, 15, 120, 120);

  ctx.save();
  ctx.fillStyle = '#FFF';
  ctx.globalAlpha = 0.5;
  ctx.fillRect(30, 30, 90, 90);

  ctx.restore();
  ctx.fillRect(45, 45, 60, 60);

  ctx.restore();
  ctx.fillRect(60, 60, 30, 30);
}

/***/ }),
/* 9 */
/***/ (function(module, exports) {


function createCanvas() {
  var el = document.createElement('canvas');
  document.body.appendChild(el);
  return el;
}

var canvasEl = createCanvas();

if (canvasEl.getContext) {
  var ctx = canvasEl.getContext('2d');
  var sin = Math.sin(Math.PI / 6);
  var cos = Math.cos(Math.PI / 6);
  ctx.translate(100, 100);
  var c = 0;
  for (var i = 0; i <= 12; i++) {
    c = Math.floor(255 / 12 * i);
    ctx.fillStyle = 'rgb(' + c + ', ' + c + ', ' + c + ')';
    ctx.fillRect(0, 0, 100, 10);
    ctx.transform(cos, sin, -sin, cos, 0, 0);
  }

  ctx.setTransform(-1, 0, 0, 1, 100, 100);
  ctx.fillStyle = 'rgba(255, 128, 255, 0.5)';
  ctx.fillRect(0, 50, 100, 100);
}

/***/ }),
/* 10 */
/***/ (function(module, exports) {


function createCanvas() {
  var el = document.createElement('canvas');
  document.body.appendChild(el);
  return el;
}

var canvasEl = createCanvas();

if (canvasEl.getContext) {
  var ctx = canvasEl.getContext('2d');
  for (var i = 0; i < 3; i++) {
    for (var j = 0; j < 3; j++) {
      ctx.save();
      ctx.fillStyle = 'rgb(' + 51 * i + ', ' + (255 - 51 * i) + ', 255)';
      ctx.translate(10 + j * 50, 10 + i * 50);
      ctx.fillRect(0, 0, 25, 25);
      ctx.restore();
    }
  }
}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.974e82d.jpg";

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lesson1__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lesson1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lesson1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lesson2__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lesson2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__lesson2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lesson3__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lesson4__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lesson4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__lesson4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lesson5__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lesson6__ = __webpack_require__(5);







/***/ })
],[12]);


// WEBPACK FOOTER //
// static/js/app.b2949b2cc31f9638f2b3.js